import { faMagnifyingGlass } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { useState } from 'react'
import ListPosts from '../Utils/ListPosts'
import { useDispatch, useSelector } from 'react-redux'
import { getActiveToken, getToken } from '../../RTK/Slice/Auth/AuthSlice'
import { notEmpty } from '../../Validation'
import { toast } from 'react-toastify'
import { getAllPostsOfGroupNextAPI, getAllPostsOfSpecificGroupAPI, getHasNext, getSpecificGroupData, getUntil } from '../../RTK/Slice/SpecificGroup/SpecificGroupSlice'

const GetGroupWithId = () => {

    // For Access Search Input
    const [groupId , setGroupId] = useState('') ; 

    // For Dispatch Action
    const dispatch = useDispatch() ; 

    // For Get Specific Group Data
    const {posts , status} = useSelector(getSpecificGroupData) ; 

    const hasNext = useSelector(getHasNext) ;

    const hasUntil = useSelector(getUntil) ; 

    // For Get Token
    const token = useSelector(getToken) ; 

    // For Get Active Token
    const userToken = useSelector(getActiveToken) ; 

    // For Search Group Handler
    const searchGroupHandler = (e)=>{
        
        e.preventDefault() ; 
        if(notEmpty(groupId)){
            dispatch(getAllPostsOfSpecificGroupAPI({token , userToken , groupId }))
        }else{
            toast.info("please enter Group ID")
        }
    }

    // For Get The Next Post On Group Handler
    const getNextPostsOfGroupHandler = ()=>{
        dispatch(getAllPostsOfGroupNextAPI({token , until : hasUntil , userToken , groupId , hasNext} ))
    }

  return (
    <div className='search-group-id-section'>

        <form className='search-group' onSubmit={searchGroupHandler}>
            <div className='search-field'>
                <FontAwesomeIcon onClick={searchGroupHandler} icon={faMagnifyingGlass} />
                <input autoFocus value={groupId} onChange={(e)=>setGroupId(e.target.value)} placeholder='Enter Group ID'/>
            </div>
            <button type="submit" className='get-group-btn'>Get Posts</button>
        </form>

        <div className='all-posts'>
            <ListPosts posts={posts}  status={status} hasNext={hasNext} hasNextHandler={getNextPostsOfGroupHandler} />
        </div>
        
    </div>
  )
}

export default GetGroupWithId
